<template>
    <div>
        <board-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                           :setFilter="setFilter" :categorys="categorys"></board-filter-link>
        <board-list-link :listLayout="listLayout" :paginationData="filterSet.page" :boardData="List"
                         :categorys="categorys" :setData="setData"></board-list-link>
        <pagination-link :paginationLayout="paginationLayout" :type="'next'" :paginationData="filterSet.page"
                         :setPage="setPage" :listLength="List.length" :setData="setData"></pagination-link>
    </div>
</template>

<script>
import VuxAlert from "@/mixins/vux-alert"
import BoardListLink from "@/components/board/BoardListLink";
import PaginationLink from "@/components/board/PaginationLink";
import BoardFilterLink from "@/components/board/BoardFilterLink";
import boardTemplateUtil from "@/components/board/boardTemplateUtil"
import boardFilterUtil from "@/components/board/boardFilterUtil"
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

const {filterConfig} = boardFilterUtil;
export default {
    name: "BoardListComponent",
    mixins: [VuxAlert, filterMixins, listMixins, boardTemplateUtil, boardFilterUtil],
    components: {
        BoardListLink,
        PaginationLink,
        BoardFilterLink
    },
    props: {
        boardType: {},
        cafeKey: {
            type: Number,
            default: () => {
                return 0
            }
        }
    },
    data() {
        return {
            PageStart: true,
            getFunc: null,
            getCategoryFunc: null,
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',
            paginationType: '',
            listApiParamSet: {},
            categorys: [],
            deleteFunc: null,
            deleteApiParamSet: {},
            deleteKeyName: '',
            deleteSuccessType: '',
            deleteIndex: 0,
            deleteLastIndex:0,
            searchInput: '',
            searchInputOption: 'su',
            filterDate: ['', ''],
            filterCountry: '',

            selectArr: [],
            isCafe: false,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
        if (this.boardType === 'JstFaq') {
            this.getCategory();
        }
    },
    mounted() {
        this.getList(true);
        EventBus.$on('getBoardList', this.getList)
        EventBus.$on('deleteBoard', this.deleteBoardConfirm)
    },
    beforeDestroy() {
        EventBus.$off('getBoardList')
        EventBus.$off('deleteBoard')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
            this.listLayout = boardTemplateConfig.listLayout;
            this.paginationLayout = boardTemplateConfig.paginationLayout;
            this.filterLayout = boardTemplateConfig.filterLayout;

            let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
            this.getFunc = boardFilterConfig.getFunc;
            this.getCategoryFunc = boardFilterConfig.getCategoryFunc;
            this.paginationType = boardFilterConfig.paginationType;
            this.listApiParamSet = boardFilterConfig.listApiParamSet;
            this.deleteFunc = boardFilterConfig.deleteFunc;
            this.deleteApiParamSet = boardFilterConfig.deleteApiParamSet;
            this.deleteKeyName = boardFilterConfig.deleteKeyName;
            this.deleteSuccessType = boardFilterConfig.deleteSuccessType;
            let pageRow = boardFilterConfig.pageRow ? boardFilterConfig.pageRow : 10;
            if (pageRow != this.filterSet.page.size) {
                this.filterSet.page.size = pageRow;
            }
            this.isCafe = boardFilterConfig.isCafe
            if (this.isCafe && this.cafeKey !== 0) {
                this.listApiParamSet.bcid = this.cafeKey
            }


            let listOptions = {
                url: this.$api.$board[this.getFunc],
                defaultParams: this.listApiParamSet,
            }
            this.initList('api', listOptions);
        },
        getCategory() {
            let params = {}
            this.$api.$board.getCategory(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type) {
                    this.categorys = res.List;
                }
            })
        },
        setData(key, value) {
            this[key] = value;
        },
        deleteBoardConfirm() {
            if (!this.deleteKeyName || this.deleteKeyName === '' || !this.deleteFunc) {
                return false;
            }
            if (this.selectArr.length === 0) {
                this.errorAlert('1개 이상 선택해주세요.');
                return false;
            }
            this.createConfirm({
                title: '',
                content: '정말 삭제하시겠습니까?',
                confirmText: '확인',
                cancelText: '취소',
                confirm: () => {
                    this.deleteIndex = 0;
                    this.deleteLastIndex = this.selectArr.length - 1;
                    this.deleteBoard();
                }
            })
        },
        deleteBoard() {
            let params = JSON.parse(JSON.stringify(this.deleteApiParamSet));
            params[this.deleteKeyName] = this.selectArr[this.deleteIndex].wr_id;
            if (this.isCafe) {
                params.c_idx = this.cafeKey
            }
            this.$api.$board[this.deleteFunc](params).then(res => res.Data.Result).then(res => {
                let returnType = this.deleteReturnType(res.Info.type);
                if (returnType == true) {
                    this.deleteAfterFunc()
                }
            })
        },
        deleteAfterFunc() {
            if (this.deleteIndex < this.deleteLastIndex) {
                this.deleteIndex = this.deleteIndex + 1;
                this.deleteBoard()
            } else {
                this.createAlert({
                    title: '',
                    content: '삭제가 완료되었습니다.',
                    btnText: '확인',
                    hide: () => {
                        this.getList();
                    }
                })
            }
        },
        deleteReturnType(type) {
            if (type == this.deleteSuccessType) {
                return true;
            } else {
                this.createAlert({
                    title: '',
                    content: '삭제에 실패하였습니다.',
                    btnText: '확인',
                    hide: () => {
                        this.getList();
                    }
                })
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>